// File: pages/AmpleAcademyPage.jsx

import React from 'react';
import "./AmpleAcademyPage.css";

import AcademyHeroSection from './AcademiySectionsComponents/AcademyHeroSection';
import LeadershipDevelopmentSection from './AcademiySectionsComponents/LeadershipDevelopmentSection';
import AcademyWorkWithLeadership from './AcademiySectionsComponents/AcademyWorkWithLeadership';
import AcademyTestimonialsSection from './AcademiySectionsComponents/AcademyTestimonialsSection';

function AmpleAcademyPage() {

  return (

    <div className="academy-page-container">

      <AcademyHeroSection />

      <LeadershipDevelopmentSection />

      <AcademyWorkWithLeadership />

      <AcademyTestimonialsSection />

    </div>

  );
}

export default AmpleAcademyPage;